class OrionCalculationEngineError {
  constructor(message, name = "InvalidAPICall", answers = {}) {
    this.message = message;
    this.name = name; // (different names for different built-in error classes)
    this.answers = answers;
  }
}

const isObject = (object) => {
  return (typeof object === "object" || typeof object === 'function') && (object !== null);
};

const getProperty = (object, propertyName) => {
  if (!propertyName) {
    return undefined;
  }
  let parts = propertyName.split( "." ),
    length = parts.length,
    i,
    property = object || {};

  for (i = 0; i < length; i++) {
    if (property.hasOwnProperty(parts[i])) {
      property = property[parts[i]];
    } else {
      // Check if dot isn't part of field name like it is in our UUIDs 
      if (i + 1 < length && property.hasOwnProperty(parts[i] + '.' + parts[i + 1])) {
        property = property[parts[i] + '.' + parts[++i]];
      } else {
        return undefined;
      }
    }
  }

  return property;
};

const executeFunction = (fn, head, tail, libraries) => {
    let functionName = fn.join('').toLowerCase();
    let library, result;
    const mathjsBlacklist = ['import', 'createUnit', 'evaluate', 'parse', 'simplify', 'derivative'];

    if (typeof libraries.mathjs[functionName] === "function" && mathjsBlacklist.indexOf(functionName) === -1) {
       library = 'mathjs';
    } else if (typeof libraries.ci[functionName] === "function") {
       library = 'ci';
    } else {
        throw new OrionCalculationEngineError("Function “" + functionName + "” is undefined and cannot be calculated", "SyntaxError");
    }

    try {
      result = libraries[library][functionName](head, ...tail);
    } catch (e) {
      throw new OrionCalculationEngineError("Error executing “" + functionName + "”", "SyntaxError");
    }

    if (typeof result !== "number") {
      throw new OrionCalculationEngineError("Function “" + functionName + "” didn't return a number", "SyntaxError");
    }

    return result;
};

const getVariable = (variableName, vars) => {
    if (vars.hasOwnProperty(variableName)) {
        try {
          return parseFloat(vars[variableName]);
        } catch (e) {
          throw new OrionCalculationEngineError("Variable “" + variableName + "” cannot be converted to float", "SyntaxError");
        }
    } else {
        throw new OrionCalculationEngineError("Variable “" + variableName + "” does not exist", "SyntaxError");
    }
}

module.exports = {
  OrionCalculationEngineError,
  isObject,
  getProperty,
  executeFunction,
  getVariable,
};